import { FeatureConfiguration } from "..";
import { ratingReducer, surveyReducer } from "./reducers";

export * from "./reducers";

export default function (config: FeatureConfiguration) {
    config.reducers.ratings = ratingReducer;
    config.reducers.survey = surveyReducer;
}
